import { jsxs as a, jsx as t } from "react/jsx-runtime";
import "react";
import { clsx as o } from "../../utils/classnames.js";
import '../../assets/Progress.css';const m = ({ value: r, showValue: e = !0, className: i, ...s }) => /* @__PURE__ */ a("div", { className: o("progress", i), ...s, children: [
  /* @__PURE__ */ a("span", { style: { display: e ? void 0 : "none" }, children: [
    r,
    "%"
  ] }),
  /* @__PURE__ */ t(
    "div",
    {
      role: "progressbar",
      "aria-valuenow": r,
      "aria-valuetext": r == null ? "indeterminate" : `${r}%`,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "data-critical": r < 50,
      style: {
        "--value": r
      }
    }
  )
] });
export {
  m as default
};
